module.exports = __webpack_public_path__ + "static/media/image_63.17aafc42.png";